<template>
    <div class="wrap" :class="click_more ? 'overflow':''">
        <!--上-->
        <div class="silution">
            <!--导航栏-->
            <div class="nav">
                <!-- <p class="logo"><img @click="logo_btn"  src="../assets/image/logo1.png" alt=""></p> -->
                <ul>
                    <li @click="silution_btn" class="silution_title">臣麦</li>
                    <li @click="product_btn" class="product_title">产品</li>
                    <li @click="service_btn" class="service_title">服务</li>
                    <li @click="contact_btn" class="contact_title">联系我们</li>
                    <li class="language">
                        <router-link  to="/" @click="chinese_btn"  :class="is_chinese ? 'pitch_on':''">CN</router-link>
                        <span></span>
                        <router-link to="/english" @click="english_btn" :class="is_english ? 'pitch_on':''">EN</router-link>
                    </li>
                </ul>
            </div>
            <!--silution image-->
            <!-- <img class="img_top" src="../assets/image/banner_silution.png" alt=""> -->
            <p class="slogan">拥有全球优质流量和自身海外媒体投放团队，为企业媒体投放和流量营销，提供专业高效的解决方案</p>
            <img class="img_bottom" src="../assets/image/banner.png" alt="">
        </div>
        <!--中-->
        <div class="product_service" ref="product">
            <p class="big_title">产品 & 服务</p>
            <p class="game_class">产品-游戏类</p>
            <ul class="game_content ">
                <li>
                    <img class="test_img image_animation" src="../assets/image/CrossyRoadNew.png" alt="">
                    <p class="title">Crossy Road</p>
                    <p class="content">《天天过马路》是一款可以勾起你儿时记忆的经典“过马路”小游戏。 游戏中玩家将控制各种萌宠…<span @click="more_btn(0)">更多</span></p>
                </li>
                <li>
                    <img class="test_img_center image_animation" src="../assets/image/SkiChallengeNew.png" alt="">
                    <p class="title small_title title_center">Ski Challenge</p>
                    <p class="content small_content content_center">《Ski Challenge》极具挑战性的休闲小游戏，人物从上…<span  @click="more_btn(1)">更多</span></p>

                </li>
                <li>
                    <!--<img src="../assets/image/the_ancient_ore.png" alt="">-->
                    <img class="test_img_right image_animation" src="../assets/image/TheAncientOreNew.png" alt="">
                    <!--<img src="../assets/image/TheAncientOre.png" alt="">-->
                    <p class="title small_title title_right">The Ancient Ore</p>
                    <p class="content small_content content_right">传统型消除游戏，但是在玩法上稍有不同…<span  @click="more_btn(2)">更多</span></p>
                </li>
            </ul>

            <div class="game_list">
                <ul>
                    <li>
                        <!--<img src="../assets/image/super_pet.png" alt="">-->
                        <img class="image_animation" src="../assets/image/SuperPetNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Super Pet</p>
                            <p class="content">《超级宠物》是经典三消游戏，通过按键上下左右选择来将同颜色三个及以上横竖相连进行消…</p>
                            <p class="more"  @click="more_btn(3)">更多</p>
                        </div>
                    </li>
                    <li>
                        <!--<img src="../assets/image/pilot_training.png" alt="">-->
                        <img class="image_animation"  src="../assets/image/PilotTrainingNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Pilot Training</p>
                            <p class="content">《Pilot Training》是一款飞行游戏，用户可以对自己的飞机外观进行自由组合。对搭配满意…</p>
                            <p class="more"  @click="more_btn(4)">更多</p>
                        </div>
                    </li>
                    <li>
                        <!--<img src="../assets/image/small_crocodile.png" alt="">-->
                        <img class="image_animation"  src="../assets/image/SmallCrocodileNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Small Crocodile</p>
                            <p class="content">一款忆旧游戏，时光荏苒，童年时光总是那么的美好…</p>
                            <p class="more other_more"  @click="more_btn(5)">更多</p>
                        </div>
                    </li>
                </ul>
                <ul>
                    <li>
                        <!--<img src="../assets/image/doodle_jump.png" alt="">-->
                        <img class="image_animation"  src="../assets/image/DoodleJumpNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Doodle Jump</p>
                            <p class="content">《涂鸦跳跃》是一款富有趣味的技巧性的游戏，在游戏中玩家要让涂鸦弹簧小怪物不停地往…</p>
                            <p class="more"  @click="more_btn(6)">更多</p>
                        </div>
                    </li>
                    <li>
                        <!--<img src="../assets/image/wake_up_santa_claus.png" alt="">-->
                        <img class="image_animation"  src="../assets/image/WakeUpSantaClausNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Wake Up Santa Claus</p>
                            <p class="content">通过消除绿色隔板，使雪花下落，通过落下的雪花唤醒圣诞老人。雪花落下过程中拾取到的…</p>
                            <p class="more"  @click="more_btn(7)">更多</p>
                        </div>
                    </li>
                    <li>
                        <!--<img src="../assets/image/danger.png" alt="">-->
                        <img class="image_animation"  src="../assets/image/DangerNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Danger</p>
                            <p class="content">《Danger》通过左右移动鼠标或者触摸屏幕的左右来使人物左右移动，利用中间的弹簧…</p>
                            <p class="more"  @click="more_btn(8)">更多</p>
                        </div>
                    </li>
                </ul>
            </div>

            <!--产品-工具类-->
            <p class="tool">产品-工具类</p>
            <div class="tool_wrap">
                <div class="left_info">
                    <!--<img src="../assets/image/qtouch.png" alt="">-->
                    <img src="../assets/image/qtouchNew.png" alt="">
                    <p class="title">Qtouch</p>
                    <p class="content">Qtouch是Android辅助操控工具软件，集成系统中的各项功能操作，使智能手机操控更加方便、轻松…<span  @click="more_btn(9)">更多</span></p>
                </div>
                <ul>
                    <li>
                        <!--<img src="../assets/image/anyRead.png" alt="">-->
                        <img class="image_animation"  src="../assets/image/AnyReadNew.png" alt="">
                         <div class="wrap_div">
                            <p class="title">AnyRead</p>
                            <p class="content">《涂鸦跳跃》是一款富有趣味的技巧性的游戏，在游戏中玩家要让涂鸦弹簧小怪物不停地往…</p>
                            <p class="more"  @click="more_btn(10)">更多</p>
                        </div>
                    </li>
                    <li class="bottom_li">
                        <!--<img src="../assets/image/SCweather.png" alt="">-->
                        <img class="image_animation"  src="../assets/image/SCweatherNew.png" alt="">
                         <div class="wrap_div">
                            <p class="title">SCweather</p>
                            <p class="content">一款使用简单，免费的天气预报，人性化设计，界面清新，可根据客户需求订做小部件，支持…</p>
                            <p class="more"  @click="more_btn(11)">更多</p>
                        </div>
                    </li>
                </ul>
            </div>

            <!--服务数据-->
            <p class="service_data_title" ref="service">服务数据</p>
            <ul class="service_data">
                <li><img src="../assets/image/instrame_cn.png" alt=""></li>
                <li><img src="../assets/image/facebook_cn.png" alt=""></li>
                <li><img src="../assets/image/google_cn.png" alt=""></li>
                <li><img src="../assets/image/tiktok_cn.png" alt=""></li>
            </ul>
        </div>
        <!--下-->
        <div class="contact_us" ref="contact_us">
            <img class="title" src="../assets/image/contact.png" alt="">
            
            <p class="email"> 
            <span>联系电话:021 3352 1187</span>
            </p>
            <p class="email">米米<span class="colon">:</span>
            <span>mimi@chenmaish.com</span>
             
            </p>
            <p class="email">
            <span>地址:上海松江區石湖荡镇酬勤路235号1幢302室</span>
            </p>
            <!-- <p class="internet_content_provider ">粤ICP备17120737号 Copyright © 2013-2020 Sinozo . All Rights Reserved .</p>
            <p class="bottom internet_content_provider">Silution</p> -->
        </div>
        <!--遮罩-->
        <div v-if="click_more" class="shade">
            <div class="detail">
                <p class="close" @click="close_btn"><img src="../assets/image/close.png" alt=""></p>
                <div class="info">

                    <img :src="detail_info.image" alt="">
                    <div class="content_block">
                        <p class="title">{{detail_info.title}}</p>
                        <p class="content">{{detail_info.content_cn}}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import mixins from "@/assets/silution.js"

    export default {
        name: "chinese_home",
        mixins: [mixins],
    }
</script>

<style scoped>

</style>